import React, { Component } from 'react';

import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';
import classnames from 'classnames';

import APButton from './../../components/atoms/APButton';
import APHeading from './../../components/atoms/APHeading';
import APLabel from './../../components/atoms/APLabel';
import { Link } from 'react-router-dom';
import { withNavigation, withTranslate } from '../../core/TenantProvider';

import MailSentSvg from './assets/mail-sent.svg';
import ReferralSentStyles from './styles/ReferralSent.style';
import { ReducerState } from '../../redux/modules';
import { TriggerGoogleAnalytics4Tag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface ReferralSentProps extends WithStyles<typeof ReferralSentStyles> {
  navigate: any,
  onReturn?: any,
  translate: Function,
  title: string,
  referralLink?: string,
  secondaryButtonText?: string,
  redirectButtontext?: string,
}

class ReferralSent extends Component<ReferralSentProps, {}> {
  private interval: ReturnType<typeof setInterval> | undefined;

  state = {
    timer: 10
  };

  constructor(props) {
    super(props);
    this.onReturnHandler = this.onReturnHandler.bind(this);
    this.handleRedirectionLinkClick = this.handleRedirectionLinkClick.bind(this);
  }

  componentDidMount() {
    this.timer();
  }

  timer() {
    const { navigate, redirectButtontext } = this.props;

    this.interval = setInterval(() => {
      this.setState((prevState: any) => {
        if (prevState.timer > 0) {
          return { timer: prevState.timer - 1 };
        } else {
          clearInterval(this.interval);
          navigate(redirectButtontext ? '/client_management' : '/account');
          return null;
        }
      });
    }, 1000);
  }


  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onReturnHandler() {
    clearInterval(this.interval);
    this.interval = undefined;

    const { onReturn } = this.props;
    onReturn?.();
  }

  handleRedirectionLinkClick() {
    const {
      redirectButtontext,
      navigate
    } = this.props;

    redirectButtontext && TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.registerClient.name,
      GoogleAnalytics4Tags.eventAction.click,
      GoogleAnalytics4Tags.registerClient.click.clientRegistrationCompleteBackToClientManagementCta
    );

    navigate(redirectButtontext ? '/client_management' : '/account');
  }

  render() {
    const {
      classes,
      translate,
      secondaryButtonText,
      redirectButtontext
    } = this.props;

    const redirectButtonCls = classnames(classes.button, {
      [classes.redirectButton]: redirectButtontext
    });

    return (
      <div className={classes.referralSentContainer}>
        <div className={classes.referralSentCopy}>
          <APHeading className={classes.referralHeading} variant="h4">
            {secondaryButtonText ? translate('register.customer.registered') : translate('referral.sent.heading')}
          </APHeading>
          <APLabel>
            {translate('register.customer.skip.proof.message.part.one')}{this.state.timer}
            {translate('register.customer.skip.proof.message.part.two')}
          </APLabel>
          <APLabel>
            {translate('register.customer.skip.proof.message.part.three')}
            <Link to={redirectButtontext ? '/client_management' : '/account'} className={classes.link}>
              {translate('register.customer.skip.proof.message.link')}
            </Link>
          </APLabel>
          <img className={classes.mailIcon} src={MailSentSvg} alt="mail" />
        </div>
        <div className={classes.referralSentButtons}>
          <APButton className={classes.button} color="primary" variant="outlined" onClick={this.onReturnHandler}>
            {secondaryButtonText ? secondaryButtonText : translate('referral.sent.button.secondary')}
          </APButton>
          <APButton
            className={redirectButtonCls}
            color="primary"
            variant="contained"
            onClick={this.handleRedirectionLinkClick}>
            {redirectButtontext ? redirectButtontext : translate('referral.sent.button.primary')}
          </APButton>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  roleAccessFunction: store.user.roleAccessFunction
});

export default withNavigation(withTranslate(withStyles(ReferralSentStyles)(connect(mapStateToProps)(ReferralSent))));
